module.exports = __webpack_public_path__ + "img/barbell-outline.1b9eaf02.svg";